let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ewLFk")).then(() => parcelRequire('3e4ZT'));